export const CompanyDocuments = ({ formData, onChange, onNext, onPrevious }) => {
    return (
        <div className="w-full">
            <h2 className="text-2xl font-bold mb-6">Documents justificatifs</h2>
            <p className="mb-6 text-gray-600">Débutant ou non, vous bénéficiez chez nous d'un accompagnement sur mesure.</p>

            <div className="mb-8">
                <h3 className="text-lg font-semibold mb-4">Chargez le logo de *Nom de l'entreprise*</h3>
                <div className="border border-dashed border-gray-300 rounded-lg p-6 mb-6">
                    <div className="flex items-center justify-center flex-col">
                        <svg className="w-10 h-10 text-gray-400 mb-2" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                        </svg>
                        <p className="text-blue-600 mb-1">Cliquez pour télécharger ou faites glisser et déposez</p>
                        <p className="text-gray-500 text-sm">(Taille max. du fichier : 25 Mo)</p>
                    </div>
                </div>
            </div>

            <div className="mb-8">
                <h3 className="text-lg font-semibold mb-4">Document administratif</h3>
                <div className="border border-dashed border-gray-300 rounded-lg p-6 mb-6">
                    <div className="flex items-center justify-center flex-col">
                        <svg className="w-10 h-10 text-gray-400 mb-2" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z" />
                        </svg>
                        <p className="text-blue-600 mb-1">Cliquez pour télécharger ou faites glisser et déposez</p>
                        <p className="text-gray-500 text-sm">(Taille max. du fichier : 25 Mo)</p>
                    </div>
                </div>
            </div>

            <div className="mb-8">
                <h3 className="text-lg font-semibold mb-4">Chargez le logo de *Nom de l'entreprise*</h3>
                <div className="border border-dashed border-gray-300 rounded-lg p-6 mb-6">
                    <div className="flex items-center justify-center flex-col">
                        <svg className="w-10 h-10 text-gray-400 mb-2" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                        </svg>
                        <p className="text-blue-600 mb-1">Cliquez pour télécharger ou faites glisser et déposez</p>
                        <p className="text-gray-500 text-sm">(Taille max. du fichier : 25 Mo)</p>
                    </div>
                </div>
            </div>
        </div>
    );
};